var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "nav",
        "vue-side-menu",
        _vm.menuHiddenClass,
        _vm.isMenuExpanded && "is-expanded"
      ],
      style: _vm.brandingVars,
      attrs: { mode: _vm.activeMode, "data-testid": "menu-div" }
    },
    [
      _c(
        "ul",
        { staticClass: "vue-side-menu__root-menu" },
        [
          _vm.showExpandButton
            ? _c(
                "li",
                {
                  staticClass: "vue-side-menu__expand-btn",
                  attrs: { "data-testid": "expand-li" },
                  on: { click: _vm.handleExpandableMenu }
                },
                [_vm._m(0)]
              )
            : _vm._e(),
          _c(
            "li",
            [
              _c("VueMenuItem", {
                staticClass: "root-item",
                attrs: {
                  menuItem: _vm.dashboardMenuItem,
                  isMenuExpanded: _vm.isMenuExpanded,
                  isTopLevel: true,
                  isMobile: _vm.isMobile,
                  companyId: _vm.menuCompanyId
                }
              })
            ],
            1
          ),
          _vm._l(_vm.menuItems, function(menuItem) {
            return _c(
              "li",
              { key: menuItem.id, staticClass: "vue-side-menu__root-item" },
              [
                menuItem.itemText == "MyVUE"
                  ? _c("hr", { staticClass: "vue-side-menu__divider" })
                  : _vm._e(),
                _c("VueMenuItem", {
                  staticClass: "root-item",
                  attrs: {
                    menuItem: menuItem,
                    isMenuExpanded: _vm.isMenuExpanded,
                    isTopLevel: true,
                    topLevelParentId: menuItem.id,
                    parentMenuIds: [menuItem.id],
                    isMobile: _vm.isMobile,
                    companyId: _vm.menuCompanyId
                  }
                }),
                menuItem.itemText == "Favorites"
                  ? _c("hr", { staticClass: "vue-side-menu__divider" })
                  : _vm._e()
              ],
              1
            )
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vue-side-menu__expand-icon" }, [
      _c("i", { staticClass: "icon icon-arrow-right-circle" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }